export enum CookieConsentPopupPositionEnum {
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_CENTER = 'bottom-center',
  CENTER = 'center',
  CENTER_LEFT = 'center-left',
  CENTER_RIGHT = 'center-right',
  TOP_RIGHT = 'top-right',
  TOP_LEFT = 'top-left',
  TOP_CENTER = 'top-center',
}